// Port de app/(tabs)/notificacoes.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const NotificacoesScreen = lazy(() => import("@/screens/Notificacoes"));

export default function NotificacoesRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <NotificacoesScreen />
    </Carregando>
  ) : null;
}
